import "../App.css";
import FormSpree from "./FormSpree";

export default function ContactMe() {
  // 1 7 1 7 1 7 1
  // 2 6 2 6 2 6 2
  // 3 5 3 5 3 5 3
  // 4 4 4 4 4 4 4
  // 5 3 5 3 5 3 5
  // 6 2 6 2 6 2 6
  // 7 1 7 1 7 1 7

  // Example starter JavaScript for disabling form submissions if there are invalid fields
  (() => {
    // Fetch all the forms we want to apply custom Bootstrap validation styles to
    const forms = document.querySelectorAll(".contact-form");

    // Loop over them and prevent submission
    Array.from(forms).forEach((form) => {
      form.addEventListener(
        "submit",
        (event) => {
          if (!form.checkValidity()) {
            event.preventDefault();
            event.stopPropagation();
          }
          form.classList.add("was-validated");
        },
        false
      );
    });
  })();

  return (
    <div
      className="tab-pane fade contact-me"
      id="contact-me-tab-pane"
      role="tabpanel"
      aria-labelledby="contact-me-tab"
      tabIndex="0"
    >
      <div className="container-fluid">
        <div className="row">
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb">
              <li className="breadcrumb-item" aria-current="page">
                <small>
                  <code>$ ~/portfolio/src/components/ContactMe.js</code>
                </small>
              </li>
            </ol>
          </nav>
        </div>
        <div className="row">
          <div className="col-12 col-md-6 mx-auto">
            <h5 className="py-4 text-center">
              Fill out this form and I'd be in touch{" "}
            </h5>
            <FormSpree />
          </div>
        </div>
      </div>
    </div>
  );
}
